"use client"
import { Heading } from "@/components/ui/Heading";
import { loadThemeComponent } from "@/core/config/theme-component-loader";
import { useDictionary } from "@/core/hooks/use-dictionary";
import { useRouter } from "next/navigation";

const CustomButton = loadThemeComponent("CustomButton")


export default function NotFound() {
  const { dictionary } = useDictionary();
  const router = useRouter()

  return (
    <div className="flex min-h-[calc(100vh-72px)]">
      <div className="m-auto max-w-1/2 bg-primary-0 border-primary-300 flex items-center justify-between rounded-md border p-4">
        <div className="text-center p-10 max-w-md m-auto">
          <Heading>
            {dictionary.ui.notFound.title}
          </Heading>
          <p className="text-primary-800 mb-6 mt-2">
            {dictionary.ui.notFound.subtitle}
          </p>
          <CustomButton
            onClick={router.back}
          >
            {dictionary.ui.notFound.back}
          </CustomButton>

          {/* <CustomButton>Default Button</CustomButton> */}

          {/* 2. Secondary variant with custom icon */}
          {/* <CustomButton variant="secondary" circleIcon={<User size={16} />}>
            Profile
          </CustomButton> */}

          {/* 3. Loading state */}
          {/* <CustomButton loading variant="black">
            Loading
          </CustomButton> */}

          {/* 4. Full width */}
          {/* <CustomButton size="full" variant="outline">
            Full Width Button
          </CustomButton> */}

          {/* 5. Ghost variant */}
          {/* <CustomButton variant="ghost" circleIcon={<Home size={16} />}>
            Ghost Button
          </CustomButton> */}

          {/* 6. TransparentWhite variant */}
          {/* <CustomButton variant="transparentWhite" circleIcon={<ChevronLeft size={16} />}>
            Transparent White
          </CustomButton> */}
        </div>
      </div>
    </div>
  );
}